import React, { useState, useEffect } from "react";
import {
  Avatar,
  Grid,
  Paper,
  Stack,
  Typography,
  Box,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appSelector } from "../redux/selector";
import { selectedJobAction } from "../redux/action";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import CandidateDashboardListSkeleton from "./CandidateDashboardListSkeleton";

const Candidatedashboardjobs = () => {
  const [loading, setLoading] = useState(true);
  const { solrJobs } = useSelector(appSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg"));

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);

  const handleJobClick = (job) => {
    if (!job?.id) return;
    dispatch(selectedJobAction(job));
    navigate("/candidates-list", {
      state: { selectedTab: 0, selectedJobId: job.id },
    });
  };

  const renderJobCard = (job, index) => (
    <Grid item xs={12} key={job?.id ?? index}>
      <Paper
        elevation={3}
        onClick={() => handleJobClick(job)}
        sx={{
          borderRadius: "8px",
          padding: "12px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          cursor: "pointer",
          transition: "transform 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <Grid container alignItems="center" spacing={1}>
          <Grid item xs={3} md={2} justifyContent="center" alignItems="center">
            <Avatar
              sx={{
                height: isDesktopSmall
                  ? "40px"
                  : isMobile || isTablet
                    ? "50px"
                    : "50px",
                width: isDesktopSmall ? "40px" : isMobile ? "50px" : "50px",
              }}
            >
              <WorkOutlineIcon sx={{ fontSize: "20px", color: "#fff" }} />
            </Avatar>
          </Grid>

          <Grid item xs={9} md={10}>
            <Stack spacing={0.5} sx={{ marginBottom: "5px" }}>
              <Typography
                variant="h6"
                title={job?.jobtitle || "Job Title"}
                sx={{
                  fontWeight: "bold",
                  fontSize: isMobileSmall
                    ? "10px"
                    : isMobile || isDesktopSmall
                      ? "10px"
                      : "15px",
                  color: "#333333",
                  lineHeight: "1.2",
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {job?.jobtitle || "Job Title"}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#666666",
                  fontSize: "13px",
                }}
              >
                {job.company_name || "Company Name"}
              </Typography>

              <Divider sx={{ marginY: "24px" }} />

              <Typography
                variant="body2"
                sx={{
                  color: "#888888",
                  fontSize: "12px",
                }}
              >
                {job?.location
                  ? job.location
                  : parseInt(job.remote) === 1
                    ? "Remote"
                    : "Location Not Available"}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );

  return (
    <Box sx={{ padding: "16px", backgroundColor: "#f4f6f8" }}>
      {loading ? (
        <CandidateDashboardListSkeleton />
      ) : solrJobs?.length > 0 ? (
        <Grid container spacing={2}>
          {solrJobs.slice(0, 10).map(renderJobCard)}
        </Grid>
      ) : (
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            marginTop: "20px",
            color: "#666666",
            fontSize: "16px",
          }}
        >
          No Jobs Found
        </Typography>
      )}
    </Box>
  );
};

export default Candidatedashboardjobs;
